<template>
  <!-- eslint-disable max-len -->
  <div>
    <main class="instant-savings-mobile u-container">
      <h1 class="font-bold text-4xl">
        Official USPS<sup>®</sup> Change-of-Address
      </h1>
      <ProgressBar
        v-if="!showChoiceExperience"
        :steps="6"
        :current="5"
      />
      <IndividualProgressBarWithSteps
        v-if="showChoiceExperience"
        :mobile="true"
      />
      <h2
        ref="stepHeading"
        class="mt-2 text-xl"
      >
        <template v-if="!showChoiceExperience">
          Step 5:&nbsp;
        </template>
        <span class="font-bold">Instant savings</span>
      </h2>
      <p class="mt-4 text-base">
        Your Change-of-Address is almost complete! Choose up to <strong>$750 in exclusive mover savings</strong> below. These offers will be sent to the email you provided.
      </p>
      <p class="mt-4 text-sm">
        Scroll and select brands you love.
      </p>
      <form
        ref="form"
        novalidate
        @submit.prevent="submit"
      >
        <div
          v-if="offers && offers.length"
          class="flex flex-col items-center mt-6"
        >
          <component
            :is="getAmpComponent(template.schema.name)"
            v-for="({ accountId, accountName, adGroupId, id, template }, objectId) in offers"
            ref="offerTile"
            :key="id"
            :value="selectedOffers.includes(offers[objectId])"
            :account-id="accountId"
            :account-name="accountName"
            :ad-id="id"
            :ad-group-id="adGroupId"
            :alt-text="accountName"
            :background-url="template.properties.backgroundUrl"
            :cta="template.properties.cta"
            :headline="template.properties.headline"
            :legal-text="template.properties.legalText"
            :logo-url="template.properties.logoUrl"
            :short-description="template.properties.shortDescription"
            :tooltip="template.properties.tooltip"
            :template-id="template.id"
            class="instant-savings-mobile__offer-tile"
            @selected:offer="toggleOfferSelect(offers[objectId])"
          />
        </div>
        <p class="mt-6 text-xs">
          Neither the U.S. Postal Service® nor any contractor associated with the operation of this website: (1) make any guarantee as to the accuracy of the statements made by the advertisers or the content of the editorial material on this website; (2) endorse any company, product or service listed or advertised in this MoversGuide Online™ product; or (3) will be held liable in any manner for any claim, loss, expense, damage or consumer dissatisfaction arising out of or in connection with the use of the MoversGuide Online™ product.
        </p>
        <StickyPanel class="mt-6">
          <template slot="buttons">
            <button
              id="next"
              ref="nextBtn"
              class="c-btn--mobile simplify__nav-button"
              @click="analytics.click.next()"
            >
              Next
            </button>
          </template>
        </StickyPanel>
      </form>
    </main>
    <Modal
      v-model="isModalOpen"
      show-x
      @input="isModalOpen = false;"
    >
      <form
        ref="modalForm"
        novalidate
        class="modal-offers-text"
        @submit.prevent="validate"
      >
        <p class="mt-6 text-blue-200 text-center font-bold">
          Would you also like to receive your offers via text to the number provided below?
        </p>
        <InputPhone
          ref="phoneInput"
          v-model="phoneNumber"
          label="Mobile Phone Number"
          placeholder="(000) 000-0000"
          name="phone"
          :has-error="errors.phoneNumber.hasError"
          class="mt-4"
          @blur="analytics.offersModal.phoneNumberField"
        >
          <template #helper>
            {{ errors.phoneNumber.message }}
          </template>
        </InputPhone>
        <p class="mt-4 text-sm text-center">
          By clicking "Yes, Send Offers", I agree to receive a promotional text message from USPS® using an automated system to my mobile phone number below. I understand that my consent to receive the text message is not required to buy goods or services. Carrier charges may apply.
        </p>
        <div class="modal-offers-text__actions mt-6">
          <button
            ref="declineTextBtn"
            type="button"
            class="modal-offers-text__cta c-btn c-btn--secondary"
            @click="submit(); analytics.offersModal.no();"
          >
            No
          </button>
          <button
            ref="sendTextBtn"
            class="modal-offers-text__cta c-btn"
            @click="registerSelections(); analytics.offersModal.sendOffers();"
          >
            Yes, Send Offers
          </button>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
import { AdvantageDouble, AdvantageSingle } from '@ampersend/mgo';
import {
  InputPhone,
  Modal,
  ProgressBar,
  IndividualProgressBarWithSteps,
} from '@mgo/ui/lib/components';
import { mobileAnalytics } from './analytics';
import InstantSavingsMixin from './mixin';
import StickyPanel from '../../components/StickyPanel.vue';

export default {
  name: 'MobileInstantSavings',
  components: {
    AdvantageDouble,
    AdvantageSingle,
    InputPhone,
    Modal,
    StickyPanel,
    ProgressBar,
    IndividualProgressBarWithSteps,
  },
  mixins: [InstantSavingsMixin],
  computed: {
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')) ?? false,
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    analytics() {
      return mobileAnalytics();
    },
    schemaNames() {
      return ['MGO Advantage Single'];
    },
  },
  watch: {
    isModalOpen(current) {
      if (current) {
        this.analytics.offersModal.opened();
      } else {
        this.analytics.offersModal.closed();
      }
    },
  },
  methods: {
    async textOffers() {
      const payload = {
        phone: this.phoneNumber.replace(/-/g, ''),
        message: await this.getAmpersendExperienceText() || null,
      };
      await this.$store.dispatch(
        'instantSavings/getTextOffers',
        payload,
      );
      this.textOffersSent = true;
      return this.submit();
    },
  },
};
</script>
